import React from 'react';

const AINewRespondentsValueProp = ({ navigateTo }) => {
  return (
    <div className="bg-black pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-6">

        {/* Back button */}
        <button 
          onClick={() => navigateTo('blog-title')} 
          className="mb-8 flex items-center text-gray-400 hover:text-white transition"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Blog
        </button>

        {/* Blog post header */}
        <header className="mb-10">
          <h1 className="text-4xl font-extrabold text-white mb-4">
            What If  HumanAI Could Cut Research Costs by 90% — and Still Get Human-Quality Insights?
          </h1>
          <div className="flex items-center text-sm text-gray-400 mb-6">
            <span>May 2025</span>
            <span className="mx-2">•</span>
            <span>4 min read</span>
            <span className="mx-2">•</span>
            <span>Product Vision</span>
          </div>
          <div className="flex items-center">
            <img 
              src={process.env.PUBLIC_URL + '/img/sharif-headshot.jpg'} 
              alt="Dr. Sharif Amlani" 
              className="h-10 w-10 rounded-full mr-3"
            />
            <div>
              <p className="text-white font-medium">Dr. Sharif Amlani</p>
              <p className="text-gray-400 text-sm">Founder & CEO, HumanAI</p>
            </div>
          </div>
        </header>

        {/* Blog content */}
        <div className="prose prose-lg prose-invert max-w-none space-y-6">

          <p className="text-lg">
            At HumanAI Ventures, our mission is simple but ambitious: <strong>to build AI respondents that mirror how real people think, feel, and decide</strong> — so you can learn faster, spend less, and make smarter decisions.
          </p>

          <p>
            Traditional research methods are expensive, slow, and hard to scale. You wait weeks for panels to fill, spend tens of thousands on surveys, and often walk away with data that’s outdated before it’s analyzed.
          </p>

          <p>
            We believe there’s a better way. What if you could run the same tests — message framing, policy feedback, campaign reactions — and get statistically reliable, human-like insights in <em>minutes</em>, not weeks? What if you could cut your costs by 90% and still get results that mirror real-world behavior?
          </p>

          <p>
            That’s the future we’re building.
          </p>

          <p>
            Our Human AI agents don’t just fill out surveys. They simulate human behavior, emotional nuance, cognitive bias, and demographic diversity. They reflect how people actually make decisions — from impulsive emotional reactions to slow, deliberative thought. And because they’re AI, they scale instantly. No recruiting. No waiting. No guesswork.
          </p>

          <p>
            This isn’t a shortcut. It’s a smarter, faster, and more affordable way to understand your audience.
          </p>

          <p className="text-lg font-semibold text-white">
            Same insights. 90% less cost. Let’s reinvent research — together.
          </p>

          <p className="mt-6 font-semibold">
            👉 <a href="#request-access" className="text-pink-400 underline hover:text-pink-300">Request early access</a> and be among the first to pilot HumanAI Respondents.
          </p>

          <div className="bg-gray-900 border border-gray-700 rounded-lg p-6 mt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div>
                <h3 className="text-xl font-bold text-white mb-2">Ready to Try Synthetic Respondents?</h3>
                <p className="text-gray-300">Experience the future of market research with HumanAI's synthetic respondent technology.</p>
              </div>
              <a 
                href="https://www.humanaienterprise.com/auth" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-pink-600 hover:bg-pink-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 whitespace-nowrap"
              >
                Use It Free
              </a>
            </div>
          </div>

          <p className="mt-6 font-semibold">— Sharif From HumanAI</p>

        </div>
      </div>
    </div>
  );
};

export default AINewRespondentsValueProp;
